__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@shipbob/b_2_b_mini_bob_mfe";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@shipbob/auth", "1.5.0", () => (__webpack_require__.e(667).then(() => (() => (__webpack_require__(3667))))));
			register("@shipbob/telemetry", "1.6.0", () => (__webpack_require__.e(36).then(() => (() => (__webpack_require__(1036))))));
			register("axios", "1.19.0", () => (__webpack_require__.e(822).then(() => (() => (__webpack_require__(2822))))));
			register("vue-axios", "3.5.2", () => (__webpack_require__.e(21).then(() => (() => (__webpack_require__(1021))))));
			register("vue-router", "4.3.0", () => (Promise.all([__webpack_require__.e(220), __webpack_require__.e(519)]).then(() => (() => (__webpack_require__(5220))))));
			register("vue", "3.5.13", () => (__webpack_require__.e(31).then(() => (() => (__webpack_require__(5031))))));
			register("vuex", "4.0.2", () => (Promise.all([__webpack_require__.e(124), __webpack_require__.e(143)]).then(() => (() => (__webpack_require__(2124))))));
			initExternal(4137);
			initExternal(2445);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};